// extracted by mini-css-extract-plugin
export const teamTile = "team-tile-module--teamTile--3zVc3";
export const image = "team-tile-module--image--2ktZu";